<template>
  <div>
    <el-collapse
      v-model="activeItems"
      :accordion="!multiple"
      @change="handleChange"
    >
      <el-collapse-item
        v-for="item in items"
        :key="item.name"
        :title="item.title"
        :name="item.name"
      >
        <slot :name="item.name" />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: 'GameCampaignAccordion',
  props: {
    items: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    active: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeItems: []
    }
  },
  mounted() {
    this.activeItems = this.active
  },
  methods: {
    handleChange() {
      this.$emit('update', this.activeItems)
    }
  }
}
</script>

<style scoped>
/deep/ .el-collapse {
  border-radius: 4px;
  border: none;
}
/deep/ .el-collapse-item {
  margin-bottom: 19px;
}
/deep/ .el-collapse-item__header {
  padding: 11px 25px;
  background: #f8fafc;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #4b515f;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  height: auto;
}
/deep/ .el-collapse-item__header.is-active {
  border-bottom-color: transparent;
  border-radius: 4px 4px 0 0;
}
/deep/ .el-collapse-item__content {
  padding: 15px 25px;
  background: white;
  border-radius: 0 0 4px 4px;
  border: 1px solid #ebeef5;
  border-top-color: #dbdee7;
}
/deep/ .el-collapse-item__wrap {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-campaigns/GameCampaignAccordion.vue